import axios from 'axios';

import {
CHANGE_DEFAULT_PERSON,
SAVE_CHANGES,
ADD_PERSON,
SET_INIT_PERSONS,
DELETE_PERSON
} from '../constants/clients-constants'

export function saveChanges(key, data) {
    return {
        type: SAVE_CHANGES,
        key,
        data
    }
}

export function setInitPersons(data) {
    return {
        type: SET_INIT_PERSONS,
        data
    }
}

export function deletePerson(key) {

    return {
        type: DELETE_PERSON,
        key
    }
}

export function initValues() {
    return function (dispatch) {
        let path, routingPath, n, result;
        const siteType = document.getElementById('app_client_contactPersons').getAttribute('data-type');
        const contactID = document.getElementById('app_client_contactPersons').getAttribute('data-id');
        if (window.fos == undefined) {
            path = "http://localhost:3005/settings"
        } else {
            path = getProperPath(siteType, contactID)
        }
        axios.get(path, {})
        .then(function (response) {
            let newValues = response.data.persons.map((person, i) => {
                return {
                    ...person,
                    key: i
                }
            });
            dispatch(setInitPersons(newValues));
        })
        .catch(function (response) {
            console.log(response)
        })
    }
}

function getProperPath(siteType, contactId) {
    switch (siteType) {
        case 'new' :
            return Routing.generate('app_client.get_contacts');
            break;
        case 'edit':
            return Routing.generate('app_client.get_contacts', {"id": contactId});
            break;
        default:
            return Routing.generate('app_client.get_contacts');
    }
}

export function handleAddPerson(data) {
    return function (dispatch) {
        dispatch(addPerson(data));
    }

}

export function addPerson(data) {
    return {
        type: ADD_PERSON,
        data
    }
}

export function changeDefaultPerson(key) {
    return {
        type: CHANGE_DEFAULT_PERSON,
        key
    }
}


// WEBPACK FOOTER //
// ./src/_app/clients/actions/clients-actions.js